import { Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";

import Home from "./pages/Home";
import Login from "./pages/Login";
import VerifyOTP from "./pages/VerifyOTP";

import Matches from "./pages/dashboard/Matches";
import Inbox from "./pages/dashboard/Activity";
import Message from "./pages/dashboard/Message";
import Upgrade from "./pages/dashboard/Upgrade";
import Chat from "./pages/dashboard/Chat";

import PublicRoute from "./routes/PublicRoute";
import ProtectedRoute from "./routes/ProtectedRoute";
import ProfileVisited from "./pages/dashboard/ProfileVisited";
import Shortlisted from "./pages/dashboard/Shortlisted";
import RequestedPhoto from "./pages/dashboard/RequestedPhoto";
import Profile from "./pages/dashboard/Profile";
import Search from "./pages/dashboard/Search";
import SearchResult from "./pages/dashboard/SearchResult";
import Filter from "./pages/dashboard/Filter";
import Settings from "./pages/dashboard/Settings";
import EditProfile from "./pages/dashboard/EditProfile";
import UnlockedProfile from "./pages/dashboard/UnlockedProfile";
import Payment from "./pages/dashboard/Payment";
import PartnerPreferences from "./pages/dashboard/PartnerPreferences";
import Notifications from "./pages/dashboard/Notifications";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Images from "./pages/dashboard/Images";
import About from "./pages/About";
import ProtectedLayout from "./routes/ProtectedLayout";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />

      <Routes>
        {/* 🌐 Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />

        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route path="/verify-otp" element={<VerifyOTP />} />

        {/* 🔒 Protected Routes with WS */}
        <Route element={<ProtectedRoute />}>
          <Route element={<ProtectedLayout />}>
            <Route path="/matches" element={<Matches />} />
            <Route path="/activity" element={<Inbox />} />
            <Route path="/message" element={<Message />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/upgrade" element={<Upgrade />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/filter" element={<Filter />} />
            <Route path="/search" element={<Search />} />
            <Route path="/search-result" element={<SearchResult />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/profile-visited" element={<ProfileVisited />} />
            <Route path="/shortlisted" element={<Shortlisted />} />
            <Route path="/requested-photo" element={<RequestedPhoto />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/unlocked-profile" element={<UnlockedProfile />} />
            <Route
              path="/partner-preferences"
              element={<PartnerPreferences />}
            />
            <Route path="/images" element={<Images />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/payment" element={<Payment />} />
          </Route>
        </Route>
      </Routes>

      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar
      />
    </>
  );
}

export default App;
